import React, { Component } from 'react';
import {NavLink, Link} from "react-router-dom";
import logodashheader  from '../Assets/logo-dash-header.png';
import FeedBackImg from '../Assets/ratings-review.png';
import Footer from "../Components/footer";
import  Header  from "../Components/header";
import SideBar from "../Components/sidebar";
import Button from "../Components/button";
import DataTable from "../Components/datatabledetails";
import { DateTime, RedirectNotLogin, RedirectNotContractor, getSession, UpdateState, getState, handleSubmit, BreedForm, AlertMessage, AlertMessageOut, serializeArray } from "../Components/function";

class Details extends Component{

  constructor(props){
    super(props);

    this.state = {
      userID : '',
      scriptID: '',
      file: '',
      message: '',
    }
    }

    componentDidMount(){
      RedirectNotLogin();
      RedirectNotContractor();
    }

    componentDidUpdate() {
      RedirectNotLogin();
      RedirectNotContractor();
    }

  render(){
    return (
        <div className="App AppWrap">

    <Header self={this}/>
    <SideBar self={this}/>

    <div className="App iBG dash-dash">
    <div className="containers">


  <div className="card-lt-wrap">
    <div className="card-lt">

     {AlertMessageOut(this)}

     <DataTable
     route="mydetails"
     badge={['', '', '']}
         thclassX={['nowrap', 'nowrap', 'nowrap', 'nowrap', 'nowrap', 'nowrap', 'nowrap', 'nowrap', 'nowrap', 'nowrap', 'nowrap']}
     th={
         ['Script ID', 'Review Outcome', 'Action', 'Publishing Status', 'Publication Date', 'Volume/Numbers', 'Issue Number', 'Pages Number', 'ISSN', 'Note (If Any)', 'Download Date']
     }
     td={
         ['scriptID', 'outcome', 'action', 'publishing_status', 'publication_date', 'volume', 'issue_number', 'pages_number', 'issn', 'note', 'added']
    }
    cmd="mydetails"
     self={this}
     />


     </div>

        <Footer classX="dash-footer"/>

    </div>

    </div>

    </div>

    </div>
    );
}

}

export default Details;